import { get, post } from '../http-calls';

export const getDriverRateByID = async (id) => {
    let res = await get(`DriverRates/${id}`, { useAuthToken: true });
    return res;
};

export const getSalesDriver_ScreenDropdown = async () => {
    let res = await get('SalesDriver/SalesDriver_ScreenDropdown', { useAuthToken: true });
    return res;
};
export const getSalesDriverByID = async (ID) => {
    let res = await get(`SalesDriver/${ID}`, { useAuthToken: true });
    return res;
};

export const postDriverRates = async (data) => {
    let res = await post('DriverRates', data, { useAuthToken: true });
    return res;
};
export const postSalesDriver = async (data) => {
    let res = await post('SalesDriver', data, { useAuthToken: true });
    return res;
};

export const getAuditorsByJob = async (jobId) => {
    let res = await get(`Auditor/GetByJob/${jobId}`, { useAuthToken: true });
    return res;
};
